const CATEGORIES = [
  { id: 'sports', label: 'Sports', emoji: '🏅', color: '#f59e0b' },
  { id: 'fitness', label: 'Fitness', emoji: '💪', color: '#ef4444' },
  { id: 'learning', label: 'Learning', emoji: '📚', color: '#10b981' },
  { id: 'social', label: 'Social', emoji: '🎉', color: '#8b5cf6' },
  { id: 'outdoors', label: 'Outdoors', emoji: '🌿', color: '#22c55e' },
  { id: 'creative', label: 'Creative', emoji: '🎨', color: '#ec4899' },
  { id: 'gaming', label: 'Gaming', emoji: '🎮', color: '#6366f1' },
  { id: 'food', label: 'Food & Cooking', emoji: '🍳', color: '#f97316' },
];

const QUICK_ACTIVITY_TYPES = [
  { id: 'sports', label: 'Badminton', emoji: '🏸' },
  { id: 'fitness', label: 'Running', emoji: '🏃' },
  { id: 'fitness', label: 'Gym', emoji: '🏋️' },
  { id: 'learning', label: 'Study', emoji: '📖' },
  { id: 'gaming', label: 'Gaming', emoji: '🎮' },
  { id: 'sports', label: 'Cricket', emoji: '🏏' },
  { id: 'sports', label: 'Football', emoji: '⚽' },
  { id: 'social', label: 'Hangout', emoji: '☕' },
];

const INTERESTS = [
  'Badminton', 'Running', 'Yoga', 'Gym', 'Swimming', 'Cycling', 'Tennis',
  'Basketball', 'Football', 'Cricket', 'Hiking', 'Cooking', 'Movies',
  'Data Science', 'Photography', 'Music', 'Gaming', 'Reading', 'Dancing',
  'Meditation', 'Art', 'Travel', 'Volunteering', 'Board Games',
];

const SOCKET_EVENTS = {
  JOIN_ROOM: 'join_room',
  LEAVE_ROOM: 'leave_room',
  SEND_MESSAGE: 'send_message',
  RECEIVE_MESSAGE: 'receive_message',
  USER_JOINED: 'user_joined',
  USER_LEFT: 'user_left',
  TYPING: 'typing',
  STOP_TYPING: 'stop_typing',
  ACTIVITY_CREATED: 'activity_created',
  ACTIVITY_EXPIRED: 'activity_expired',
  INTENT_CREATED: 'intent_created',
  NEW_NOTIFICATION: 'new_notification',
  NEW_MESSAGE: 'new_message',
  /** Server bumped tokenVersion — client must clear session (moderation, admin revoke). */
  SESSION_REVOKED: 'session_revoked',
};

const DEFAULT_RADIUS_KM = 10;
const MAX_RADIUS_KM = 50;

/** After the listing window ends (`expiresAt` or scheduled `dateTime`), participants can still send chat for this long. */
const ACTIVITY_CHAT_GRACE_AFTER_LISTING_MS = 3 * 24 * 60 * 60 * 1000;

module.exports = {
  CATEGORIES,
  QUICK_ACTIVITY_TYPES,
  INTERESTS,
  SOCKET_EVENTS,
  DEFAULT_RADIUS_KM,
  MAX_RADIUS_KM,
  ACTIVITY_CHAT_GRACE_AFTER_LISTING_MS,
};
